interface DragDropItemData {
  id: number;
  name: string;
  required: boolean;
}
export const reorder = (
  list: Array<DragDropItemData>,
  startIndex: number,
  endIndex: number
): Array<DragDropItemData> => {
  const result: Array<DragDropItemData> = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const getDeletedItems = (
  prevArray: Array<DragDropItemData>,
  itemID: number
): Array<DragDropItemData> => {
  const newItemsArray: Array<DragDropItemData> = [];
  let idIncremented = true;
  let after = false;

  for (const item of prevArray) {
    if (item.id === itemID && idIncremented) {
      idIncremented = false;
      after = true;
    } else if (item.id > itemID && (after || idIncremented)) {
      item.id -= 1;
      newItemsArray.push(item);
    } else {
      newItemsArray.push(item);
    }
  }
  return newItemsArray;
};

export const getDuplicatedItems = (
  prevArray: Array<DragDropItemData>,
  itemID: number
): Array<DragDropItemData> => {
  const newItemsArray: Array<DragDropItemData> = [];
  let idIncremented = true;
  let after = false;

  for (const item of prevArray) {
    if (item.id === itemID && idIncremented) {
      newItemsArray.push(item);
      const duplicateItem = { ...item };
      duplicateItem.id += 1;
      duplicateItem.name = `${item.name} Copy`;
      newItemsArray.push(duplicateItem);
      idIncremented = false;
      after = true;
    } else if (item.id > itemID && (idIncremented || after)) {
      item.id += 1;
      newItemsArray.push(item);
    } else {
      newItemsArray.push(item);
    }
  }
  return newItemsArray;
};
